module.exports = [{path:'/summary',componentPath:'Reinstatement/Summary/Summary'},{path:'/risk-analysis',componentPath:'Reinstatement/UWWorkBench/UWWorkBench'}]